import vittal from 'assets/images/VittalRamakrishna.png';
import kanishk from 'assets/images/KanishkSingh.png';
// import enisha from 'assets/images/EnishaKalita.png';
import sweety from 'assets/images/SweetyValechha.png';
// import sweta from 'assets/images/SwetaSingh.png';
import athulya from 'assets/images/AthulyaMohan.png';
import vimal from 'assets/images/Vimal.png';
import JoinPOD from 'assets/images/joinPOD.png';

import { MemberCard, MemberType } from './MemberCard';
import { Container, Grid } from '@mui/material';

const members: MemberType[] = [
  {
    name: 'Vittal Ramakrishna',
    designation: 'Founder, CEO',
    image: vittal,
  },
  {
    name: 'Kanishk Singh',
    designation: 'Investor Relations',
    image: kanishk,
  },
  // {
  //   name: 'Enisha Kalita',
  //   designation: 'Program Manager',
  //   image: enisha,
  // },
  {
    name: 'Sweety Valechha',
    designation: 'Head of Product',
    image: sweety,
  },
  {
    name: 'Vimal Bhalani',
    designation: 'Full Stack Developer',
    image: vimal,
  },
  // {
  //   name: 'Sweta Singh',
  //   designation: 'Legal and Compliance Manager',
  //   image: sweta,
  // },
  {
    name: 'Athulya Mohan',
    designation: 'HR & Operations Associate',
    image: athulya,
  },
];

export const Members = () => {
  return (
    <Container
      sx={{
        mt: '-189px',
        p: {
          xs: 0,
          md: 'inherit',
        },
      }}
    >
      <Grid
        container
        sx={{
          // borderRadius: '20px',
          borderRadius: {
            xs: 0,
            md: '20px',
          },
          backgroundColor: '#fff',
          // p: '70px 60px 35px',
          p: {
            xs: 0.5,
            md: '70px 60px 35px',
          },
        }}
      >
        {members.map((member, i) => (
          <MemberCard key={i} {...member} />
        ))}
        <MemberCard image={JoinPOD} href="mailto:career@podworld.in" />
      </Grid>
    </Container>
  );
};
